import { isPositionModelWithLatLng, PositionModel } from '@customer/store/apis/assetsApi';
import { LatLng, latLngBounds } from 'leaflet';
import { useMemo } from 'react';
import { MapViewProps } from '../map-view/MapView';

export const usePositionsOnMap = (
  positionModels: Array<PositionModel | null | undefined>,
): MapViewProps => {
  return useMemo<MapViewProps>(() => {
    const data: LatLng[] = [];

    positionModels.forEach((positionModel: PositionModel | null | undefined) => {
      if (positionModel && isPositionModelWithLatLng(positionModel)) {
        data.push(new LatLng(positionModel.lat, positionModel.lon));
      }
    });

    if (data.length > 1) {
      // Only set bounds if there are two or more positions.
      return { bounds: latLngBounds(data) };
    } else if (data.length === 1) {
      // If there's only one data point, set the initial centre to that point.
      return { initialCentre: data[0] };
    } else {
      return {};
    }
  }, [positionModels]);
};

export default usePositionsOnMap;
